
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { ContentPage } from 'components/pages/ContentPage';
import { HeadComponent } from 'components/pages/Head';
import { getTranslations } from 'helpers/translations';
import { ISR_REVALIDATE_TIME } from 'lib/constants';
import { CampaignPageContent, ContentPage as ContentPageModel } from 'models';
import { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from 'next';
import React from 'react';
import safeJsonStringify from 'safe-json-stringify';
import { Translations } from 'store/translations';
import { GetContentPage } from 'utils/sitemap';
import { getLocaleVariants } from './api/locale';
import { normalize } from './api/sitemap';
const uniqueSlugCheck = (page: ContentPageModel, slugs: string[], translations: Translations) => {
    const realUrl = Object.keys(normalize(page, undefined, undefined, true, translations))[0];
    if (realUrl !== `/${slugs.join('/')}`)
        return {
            redirect: {
                destination: realUrl ?? '/',
                permanent: true,
            },
        };
};
export type ContentViewProps = {
    model: ContentPageModel;
};
export const ContentView = ({ model }: ContentViewProps) => {
    return (<>
      {model && <HeadComponent page={model}/>}
      {model && <ContentPage key={model.system.id} content={model}/>}
    </>);
};
export default ContentView;
export const getStaticPaths: GetStaticPaths = () => {
    return {
        paths: [],
        fallback: true,
    };
};
const getStaticProps: GetStaticProps<ContentViewProps> = async (ctx) => {
    return await _getDynamicPage(ctx);
};
export const _getDynamicPage = async (ctx: GetStaticPropsContext) => {
    const languageCodename = ctx.locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!;
    const slugs = ctx.params?.slug ?? (ctx.params ? Object.values(ctx.params) : undefined);
    const lastSlug = slugs && (slugs[slugs.length - 1] as string);
    const slugCheckPage = lastSlug && (await GetContentPage.bySlug(languageCodename, lastSlug, false));
    if (!slugCheckPage)
        return {
            redirect: {
                destination: `${languageCodename === process.env.NEXT_PUBLIC_DEFAULT_LOCALE! ? '' : `/${languageCodename}`}/404`,
                permanent: false,
            },
        };
    const translations = await getTranslations(languageCodename);
    const redirectIfNotUniqueSlug = uniqueSlugCheck(slugCheckPage, slugs as string[], translations);
    if (redirectIfNotUniqueSlug)
        return redirectIfNotUniqueSlug;
    const page = await GetContentPage.bySlug(languageCodename, lastSlug, true);
    let navigationCodename;
    if (process.env.NEXT_PUBLIC_KONTENT_AI_COLLECTION?.includes('default')) {
        navigationCodename =
            page?.elements.category.value[0]?.codename === 'campaign'
                ? (page.elements.content.linkedItems[0] as CampaignPageContent).elements.navigation.linkedItems[0]?.system
                    .codename
                : undefined;
    }
    else {
        navigationCodename =
            page?.elements.category.value[0]?.codename === 'campaign'
                ? (page.elements.content.linkedItems[0] as CampaignPageContent).elements.navigation.linkedItems[0]?.system.codename.concat('_' + process.env.NEXT_PUBLIC_KONTENT_AI_COLLECTION)
                : undefined;
    }
    let footerCodename;
    if (process.env.NEXT_PUBLIC_KONTENT_AI_COLLECTION?.includes('default')) {
        footerCodename =
            page?.elements.category.value[0]?.codename === 'campaign'
                ? (page.elements.content.linkedItems[0] as CampaignPageContent).elements.footer.linkedItems[0]?.system.codename
                : undefined;
    }
    else {
        footerCodename =
            page?.elements.category.value[0]?.codename === 'campaign'
                ? (page.elements.content.linkedItems[0] as CampaignPageContent).elements.footer.linkedItems[0]?.system.codename.concat('_' + process.env.NEXT_PUBLIC_KONTENT_AI_COLLECTION)
                : undefined;
    }
    // const footerCodename =
    //   page?.elements.category.value[0]?.codename === 'campaign'
    //     ? (page.elements.content.linkedItems[0] as CampaignPageContent).elements.footer.linkedItems[0]?.system.codename
    //     : undefined;
    const partOfCampaignCodename = (page?.elements.partOfCampaignPage.linkedItems[0]?.elements.category.value[0].codename.includes('campaign') &&
        page.elements.partOfCampaignPage.linkedItems[0].system.codename) ||
        undefined;
    const variants = lastSlug?.length && !lastSlug.includes('_')
        ? ((await getLocaleVariants(lastSlug, languageCodename, true)) as {
            [key: string]: string;
        })
        : undefined;
    return {
        props: JSON.parse(safeJsonStringify({
            model: page,
            layout: { footerCodename, navigationCodename, partOfCampaignCodename },
            variants,
        })) as ContentViewProps,
        revalidate: ISR_REVALIDATE_TIME,
    };
};

    async function __Next_Translate__getStaticProps__1a0ae9df721__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[...slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0ae9df721__ as getStaticProps }
  